import { SUBFOLDERS_TYPES } from '../../../pages/virtualOffice/shared/enums/documents-subfolders';
import { getError } from '../../utils';
import axios from 'axios';
import CustomHttpClient from '../customHttpClient';
import { ContactIndexResponse } from '../../interfaces/services/get-contact-index';
import { AreaComboList } from '../../interfaces';

const PREFIX = 'oficina-virtual/';
const URL_S3 = process.env.REACT_APP_S3_URL;

const customHttpClient = CustomHttpClient({ baseUrl: 'productores' });

const metadataCache = new Map<string, any>();


const VirtualOfficeService = {
  async getFormsList(subFolder: SUBFOLDERS_TYPES): Promise<any[]> {
    try {
      const response = await axios.get(`${URL_S3}`, {
        params: {
          'list-type': 2,
          prefix: PREFIX,
        },
        responseType: 'text',
      });

      const xml = response.data;
      const parser = new DOMParser();
      const doc = parser.parseFromString(xml, 'application/xml');

      const contents = Array.from(doc.getElementsByTagName('Contents'));

      const items = contents
        .filter((c) => {
          const key = c.getElementsByTagName('Key')[0]?.textContent || '';
          return key !== PREFIX;
        })
        .map((c) => {
          const key = c.getElementsByTagName('Key')[0].textContent;
          const lastModified =
            c.getElementsByTagName('LastModified')[0].textContent;
          const size = c.getElementsByTagName('Size')[0].textContent;

          return {
            key,
            lastModified,
            size,
            url: `${URL_S3}${key}`,
          };
        })
        .filter((item) => item.key && !item.key.endsWith('/'));

      const documents = items.filter((doc: any) =>
        doc.key.includes(`oficina-virtual/${subFolder}`)
      );

      // Ordenar por fecha de publicación descendente
      documents.sort((a, b) => {
        const dateA = a.lastModified ? new Date(a.lastModified).getTime() : 0;
        const dateB = b.lastModified ? new Date(b.lastModified).getTime() : 0;
        return dateB - dateA;
      });

      return documents;
    } catch (error) {
      throw new Error(getError(error));
    }
  },


  async getMetadata(key: string) {
    if (metadataCache.has(key)) {
      return metadataCache.get(key);
    }
  
    const res = await axios.head(`${URL_S3}${key}`);
    const metadata = {
      contentType: res.headers['content-type'],
      contentLength: res.headers['content-length'],
      contentDisposition: res.headers['content-disposition'],
      eTag: res.headers['etag'],
      lastModified: res.headers['last-modified'],
      branch: res.headers['x-amz-meta-branch'],
      description: res.headers['x-amz-meta-description'],
      nombre: res.headers['x-amz-meta-nombre'],
    };
  
    metadataCache.set(key, metadata);
    return metadata;
  },
  

  async getIndexContacts(): Promise<ContactIndexResponse> {
    const url = 'listaContactos';
    try {
      const response = await customHttpClient.get(url);
      return response.data;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getAreaCombo(): Promise<AreaComboList> {
    const url = 'listaAreas';
    try {
      const response = await customHttpClient.get(url);
      return response.data;
    } catch (error) {
      throw new Error(getError(error));
    }
  },


};

export default VirtualOfficeService;
